// extracted by mini-css-extract-plugin
module.exports = {"game":"_7f6ea1","gameInner":"_16e63e"};